import { useState, useMemo, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "../../scss/App.scss";
import Filters from "../main/Filters";
import ResultsTable from "../main/ResultsTable";
import Pagination from "../main/Pagination";
import axios from "axios";

function Search() {
    const [documents, setDocuments] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [filters, setFilters] = useState({});
    const [appliedFilters, setAppliedFilters] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    const handleFilterChange = (newFilters) => setFilters(newFilters);

    useEffect(() => {
        const paramsObj = {};
        searchParams.forEach((value, key) => {
            paramsObj[key] = value;
        });
        setFilters(paramsObj);
        setAppliedFilters(paramsObj);
        setIsInitialized(true);
    }, [searchParams]);

    useEffect(() => {
        if (!isInitialized) return;
        const fetchDocuments = () => {
            setLoading(true);
            axios.get(`/apiv1/cards/${currentPage}`, {
                params: appliedFilters,
            }).then((response) => {
                setDocuments(response.data.data);
                setLoading(false);
            });
        };

        fetchDocuments();
    }, [appliedFilters, currentPage, isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;
        const fetchMaxPage = () => {
            axios.get(`/apiv1/max-page`, {
                params: appliedFilters,
            }).then((response) => {
                setTotalPages(response.data.data);
            });
        };

        fetchMaxPage();
    }, [appliedFilters, isInitialized]);

    const applyFilters = () => {
        setAppliedFilters(filters);
        setSearchParams(filters);
        setCurrentPage(1);
    };

    const resetFilters = () => {
        setFilters({});
        setAppliedFilters({});
        setSearchParams({});
        setCurrentPage(1);
    };

    const currentItems = useMemo(() => documents, [currentPage, documents]);

    return (
        <>
            <Filters
                initialFilters={appliedFilters}
                onChange={handleFilterChange}
                onSubmit={applyFilters}
                onReset={resetFilters}
            />
            {loading ? (
                <div className="loading">
                    <div className="loading-spinner"></div>
                    <div className="loading-text">Ładowanie danych...</div>
                </div>
            ) : (
                <ResultsTable documents={currentItems} />
            )}
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
            />
        </>
    );
}

export default Search;
